import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components";
import moment from "moment-timezone";
import { BoldTitle, Title } from "../../routes/main-styles";

function Timeline({
  items = [],
}) {
  console.log("Timeline items:", items);
  
  return (
    <>
      <Title style={{marginBottom: 20}}>Linha do tempo</Title>
      <TimelineContainer>
        <VerticalLine />
        {items.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineIcon>
              <FontAwesomeIcon icon={faFlag} />
            </TimelineIcon>
            <TimelineContent>
              <TimelineText>{item.status}</TimelineText>
              <TimelineDate>
                {moment(item.date).format("DD/MM/YY HH:mm")}
              </TimelineDate>
            </TimelineContent>
          </TimelineItem>
        ))}
      </TimelineContainer>
    </>
  );
}

const TimelineText = styled.div`
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
`;

const TimelineDate = styled.div`
  color: #a1a1a1;
  font-size: 12px;
  font-weight: 400;
`;

const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
`;

const TimelineItem = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  font-size: 12px;
`;

const TimelineContent = styled.div`
  margin-left: 40px;
`;

const TimelineIcon = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background: ${props => props.theme.primary};
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const VerticalLine = styled.div`
  position: absolute;
  left: 14px;
  top: 0;
  bottom: 15px;
  width: 2px;
  background: #ddd;

`;
export default Timeline;
